// sso.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class SSOService {
  private apiUrl = '/onlinetesting/rest/utilities/singleSignOnLink';

  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

  getSSOLink(authKey: string, screenName?:string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-SelectionToken': authKey,
    });
    const requestData = {
      screenName: screenName || '/onlinetesting/odi/flashassets/',
      optOut: false
    };

    return this.httpClient.post<number>(this.apiUrl, requestData, { headers: headers });
  }
}
